import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import { useRecoilState, useRecoilValue } from "recoil";
import {
    userInfo,
    userCredentials,
    routeInfo,
    rioNegroServices,
} from "recoilState/GlobalState";

import { Routes } from "consts/Routes-App";
import { logout } from "services/Local-services";

import { ListDrawer } from "components";

import {
    AppBar,
    Box,
    Drawer,
    IconButton,
    Toolbar,
    Typography,
} from "@mui/material";
import { GridMenuIcon } from "@mui/x-data-grid";

import LogoutIcon from "assets/icons/icon-logout.svg";
import { LogoMIAFooter, UserPlaceholder } from "assets/icons";
import { LogoGobiernoRN } from "assets/icons/servicios";

import { tramosDeLaRuta } from "./breadcrumb";

import styles from "./Header.module.scss"

export default function Header() {
    const [openDrawer, setOpenDrawer] = useState(false);

    const [user, setUser] = useRecoilState(userInfo);
    const credentials = useRecoilValue(userCredentials);
    const route = useRecoilValue(routeInfo);
    const location = useLocation();
    const servicios = useRecoilValue(rioNegroServices);

    // El camino hasta la vista actual, sacado del menu. `null` en las pantallas que no cuelgan
    // de un servicio (Dashboard, Usuarios globales): ahi se sigue mostrando el titulo de antes.
    const tramos = tramosDeLaRuta(location.pathname, servicios);

    const handleDrawerOpen = async () => {
        setOpenDrawer(!openDrawer);
    };

    return (
        <>
            <AppBar position="relative" className={styles.root}>
                <Toolbar
                    variant="dense"
                    className={styles.toolbar}
                >
                    <div className={styles.menu}>
                        <IconButton
                            edge="start"
                            aria-label="menu"
                            color="inherit"
                            onClick={handleDrawerOpen}
                        >
                            <GridMenuIcon className={styles.menuIcon} />
                        </IconButton>

                        {tramos ? (
                            <nav className={styles.breadcrumb} aria-label="Ubicación">
                                {tramos.map((tramo, indice) => (
                                    <React.Fragment key={`${indice}-${tramo}`}>
                                        {indice > 0 && (
                                            <span className={styles.separador} aria-hidden="true">
                                                ›
                                            </span>
                                        )}
                                        <span
                                            className={
                                                indice === tramos.length - 1
                                                    ? styles.tramoActual
                                                    : styles.tramo
                                            }
                                            // El ultimo tramo es donde esta parado el usuario.
                                            aria-current={
                                                indice === tramos.length - 1 ? "page" : undefined
                                            }
                                        >
                                            {tramo}
                                        </span>
                                    </React.Fragment>
                                ))}
                            </nav>
                        ) : (
                            <Typography
                                className={styles.wordKey}
                                color="inherit"
                                variant="h4"
                            >
                                {route?.wordKey
                                    ? route.wordKey === "Usuarios - Programa Asiste RN" ? "Administrativos - Programa Asiste RN" : route.wordKey
                                    : (Object.values(Routes).find(route => route.route === location.pathname))?.wordKey}
                            </Typography>
                        )}
                    </div>
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} width={"33%"} >
                        <Typography
                            className={styles.merchantLogo}
                            color="inherit"
                            variant="h4"
                        >

                            {credentials.merchantNombre}
                        </Typography>
                    </Box>

                    <div className={styles.userData}>
                        <p>{user?.usuarioNombres} {" "} {user?.usuarioApellidos}</p>
                        <img src={user?.imagePathPERFIL} alt="" onError={() => setUser((data) => ({ ...data, imagePathPERFIL: UserPlaceholder }))} />
                    </div>
                </Toolbar>
            </AppBar>

            <Drawer
                className={styles.drawer}
                variant="persistent"
                anchor="left"
                open={openDrawer}
            >
                <div className={styles.drawerHeader}>
                    {/* Logo fijo del Gobierno de RN (nuevo logo actual). Para el uso real
                        hay que cambiarlo en el back: viene de MerchantLogoGet → user.imagePathLOGO.
                        Reemplazar `LogoGobiernoRN` por `user?.imagePathLOGO` cuando el back lo sirva. */}
                    <img
                        src={LogoGobiernoRN}
                        alt="Logo"
                        onError={() => setUser((data) => ({ ...data }))}
                        className={styles.logo}
                    />
                </div>
                <div className={styles.listContainer}>
                    <ListDrawer setOpen={setOpenDrawer} />
                </div>
                <div className={styles.logout} onClick={logout}>
                    <img src={LogoutIcon} alt="Logout" />
                    Cerrar Sesión
                </div>
                <div className={styles.drawerFooter}>
                    <div>
                        Powered by <img src={LogoMIAFooter} alt="" />
                    </div>
                    <p>Versión 1.0.9</p>
                </div>
            </Drawer>
            {openDrawer && (
                <div
                    className={styles.drawerHandler}
                    onClick={() => setOpenDrawer(false)}
                />
            )}
        </>
    );
}
